"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashRequestURL = void 0;
const hashRequestURL = (url) => {
    const { pathname } = new URL(url);
    const hash = pathname
        .substring(1)
        .split('')
        .reduce((a, b) => {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
    }, 0);
    return hash;
};
exports.hashRequestURL = hashRequestURL;
//# sourceMappingURL=authoriser.helper.js.map